<template lang="pug">
  Swatches.rogue-related(
    v-if="productIds.length"
    label="Related"
    code="rogue-related"
    :modelValue="selectedOption"
    :options="related"
  )
</template>
<script>
import { useProductStore } from '@/js/stores/productStore'

export default {
  name  : 'rogue-related',
  props : {
    // Can either pass a specific productId - which will auto-load the products for that
    productIds: {
      type    : Array,
      default : () => ([]),
    },
  },

  setup() {
    const productStore = useProductStore()

    return { productStore }
  },

  computed: {
    products() {
      return this.productStore.products
    },

    selectedOption() {
      return this.related.find(r => r.link === this.$route.path)?.value || null
    },

    related() {
      return this.productIds
        .map(id => this.products[id])
        .filter(p => !!p)
        .map(product => ({
          image     : (product.relatedProductImage || product.thumbnail || product.image),
          value     : product.productId,
          productId : product.productId,
          link      : product.url,
          metaTitle : product.attributes.meta_title || product.name,
        }))
    },
  },

  watch: {
    productIds: {
      immediate : true,
      deep      : true,
      handler() {
        return this.load()
      },
    },
  },

  serverPrefetch() {
    return this.load()
  },

  methods: {
    async load() {
      const relatedIds = this.productIds.slice(0)

      if (relatedIds.find(productId => !this.products[productId])) {
        await this.productStore.loadAll(relatedIds, this.$rogue)
      }

      // When switching between related products, we don't want to reset the order every time.
      // This only applies to the old style - when there is no rhpaTop
      if (this.value && relatedIds.length > 0 && !relatedIds.includes(this.value)) {
        relatedIds.unshift(this.value)
        relatedIds.forEach(productId => this.productStore.syncRelated(productId, relatedIds))
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.rogue-related.swatches-container:deep() {
  a {
    color: $color-black;
    text-decoration: none;
  }
}

</style>
